import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import ServicesGrid from '../components/ServicesGrid';
import Newsletter from '../components/Newsletter';

export default function ServicePage({ kicker, title, titleAccent, hero, lead, image, bullets, body, ctaPrimary, excludeId }) {
  return (
    <div>
      <section className="pt-36 pb-12 px-6 lg:px-10">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-[#d4b574] mb-4">{kicker}</div>
            <h1 className="font-serif-display text-5xl md:text-6xl text-[#f5efe3] leading-[1.05]">
              {title} <span className="italic text-gold-grad">{titleAccent}</span>
            </h1>
            <p className="mt-6 text-[#cfc6b5] text-lg leading-relaxed">{lead}</p>
            {bullets && (
              <ul className="mt-6 space-y-2.5">
                {bullets.map((b, i) => (
                  <li key={i} className="flex items-start gap-3 text-[#cfc6b5]">
                    <Check size={18} className="text-[#d4b574] mt-0.5 flex-shrink-0" /> <span>{b}</span>
                  </li>
                ))}
              </ul>
            )}
            <div className="mt-8 flex flex-wrap gap-3">
              {ctaPrimary && (
                <a
                  href={ctaPrimary.href}
                  target={ctaPrimary.external ? '_blank' : undefined}
                  rel={ctaPrimary.external ? 'noreferrer' : undefined}
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#d4b574] text-[#0a0a0c] font-medium hover:bg-[#e8d5a8] transition-colors"
                >
                  {ctaPrimary.label} <ArrowRight size={16} />
                </a>
              )}
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/15 text-[#cfc6b5] hover:border-[#d4b574]/40 hover:text-[#e8d5a8] transition-all"
              >
                Zum Kontaktformular
              </Link>
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#d4b574]/15 to-transparent rounded-3xl blur-2xl" />
            <div className="relative rounded-3xl overflow-hidden border border-[#d4b574]/15">
              <img src={hero || image} alt={title} className="w-full h-auto" />
            </div>
          </div>
        </div>
      </section>

      <section className="px-6 lg:px-10 py-16">
        <div className="max-w-4xl mx-auto space-y-6 text-[#cfc6b5] leading-relaxed">
          {body.map((p, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
          ))}
        </div>
      </section>

      <section className="px-6 lg:px-10 py-16 border-t border-white/5 bg-[#08080a]">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between gap-6 mb-10">
            <div>
              <div className="text-xs uppercase tracking-[0.28em] text-[#d4b574] mb-3">Weitere Angebote</div>
              <h2 className="font-serif-display text-3xl md:text-4xl text-[#f5efe3]">Entdecke mehr <span className="italic text-gold-grad">Lösungen</span></h2>
            </div>
            <Link to="/angebot" className="hidden md:inline-flex items-center gap-2 text-sm text-[#d4b574] hover:gap-3 transition-all">
              Alle Angebote <ArrowRight size={14} />
            </Link>
          </div>
          <ServicesGrid excludeId={excludeId} />
        </div>
      </section>

      <Newsletter />
    </div>
  );
}
